import { connect } from 'react-redux';
import TeamMembers from '../../components/Clients/EditClientProfile/TeamMembers';
import {getClientUsers, rollbackStatus} from '../../actions/Clients'

import {initial} from 'lodash'

import {
  getRoles,
  getClientRoles,
  updateProfile,
  rollBackUpdateStatus,
  sendClientUserInvite,
} from "../../actions/employees";

import {
  inviteBusinessMember,
  send_invitation,
  getBusinessUnitTeamMembers,
  sendInviteBusinessUnitMember
} from '../../actions/Clients'

const mapStateToProps = (state) => {
	const { client_team_members } = state.clients
	const { roles, clientRoles,
    ifUpdateSuccess, updateErrorText, sendInvite_error_message } = state.employees;
  const { ifSendInvitationSuccess, send_invitation_error_msg, business_unit_team_members, ifInviteBusinessUnitMemberSuccess } = state.clients;
  const { userId, roleId, roleName } = state.app;
	return {
		roles : (roleId > 50) ? clientRoles.filter(item => item.value !== 53) : roles,
    clientRoles : initial(clientRoles),
    ifSendInviteSuccess:ifSendInvitationSuccess,
    ifUpdateSuccess,
    updateErrorText,
    userId,
    roleId,
    sendInvite_error_message,
    tableList: (client_team_members !== undefined && client_team_members.data) ? client_team_members.data : client_team_members,
    origin_tableList: client_team_members,
    ifSendInvitationSuccess, 
    send_invitation_error_msg,
    roleName,
    business_unit_team_members,
    ifInviteBusinessUnitMemberSuccess
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		getRoles: () => {
      dispatch(getRoles());
    },
    getClientRoles: () =>{
      dispatch(getClientRoles())
    },
    sendInvite: (obj) => {
      dispatch(send_invitation(obj));
    },
    sendClientInvite: (obj) => {
      dispatch(sendClientUserInvite(obj))
    },
    rollbackStatus: () => {
      dispatch(rollbackStatus());
		},    
		updateProfile: (id, obj) => {
      dispatch(updateProfile(id, obj))
    },
    rollBackUpdateStatus: () => {
      dispatch(rollBackUpdateStatus());
    },
		getClientUsers: (req, clientId) => {
			dispatch(getClientUsers(clientId, req))
    },
    inviteBusinessMember: (obj)=>{
      dispatch(inviteBusinessMember(obj))
    },
    getBusinessUnitTeamMembers: (clientId, businessId) => {
		  dispatch(getBusinessUnitTeamMembers(clientId, businessId));
    },
    sendInviteBusinessUnitMember: (obj) => {
		  dispatch(sendInviteBusinessUnitMember(obj))
    }
	}
}

const ClientTeamMembers = connect (
  mapStateToProps,
  mapDispatchToProps
)(TeamMembers);

export default ClientTeamMembers;



// WEBPACK FOOTER //
// ./src/containers/Clients/TeamMembers.js